import logo from './logo.svg';
import React, { useState } from 'react'
import './App.css';
import Navbar from './components/Navbar';
import TextForm from './components/TextForm';
import About from './components/About';

import {
  BrowserRouter as Router,
  Routes ,
  Route,
  Link
} from "react-router-dom";

function App() {
  // const [mode, setmode] = useState('light');
  const [mode, setmode] = useState('light');

  const togglemode = () => {
    if (mode === 'light') {
      setmode('dark');
      document.body.style.backgroundColor = 'rgb(5, 20, 30)';
      document.body.style.color = 'white';
      // document.title = 'TextUtils: Dark Mode'

    }
    else {
      setmode('light');
      document.body.style.backgroundColor = 'white';
      document.body.style.color = 'black';
      // document.title = 'TextUtils: Light Mode'

    }
  }

  const toggletitle1=()=>{
    if(document.title=='TextUtils: About'){
      document.title="TextUtils: Home"
    }
    else{
      document.title="TextUtils: Home"
    }
  }

  const toggletitle2=()=>{
    if(document.title=='TextUtils: Home'){
      document.title="TextUtils: About"
    }
    else{
      document.title="TextUtils: About"
    }
  }



  return (
    // <div className="App">
    //   <header className="App-header">
    //     <img src={logo} className="App-logo" alt="logo" />
    //     <p>
    //       Edit <code>src/App.js</code> and save to reload.
    //     </p>
    //     <a
    //       className="App-link"
    //       href="https://reactjs.org"
    //       target="_blank"
    //       rel="noopener noreferrer"
    //     >
    //       Learn React
    //     </a>
    //   </header>
    // </div>

    <>
      <Router>
        <Navbar title="TextUtils" mode={mode} togglemode={togglemode} toggletitle1={toggletitle1} toggletitle2={toggletitle2}/>
        <div className="container my-3">

          <Routes >
            <Route exact path="/TextUtils-React.js/" element={<TextForm heading="Enter Your Text Below"  />}/>
            <Route exact path="/about" element={<About />}/>
              
            
            {/* <Route path="/about">
              <About />
            </Route> */}
          </Routes>
        </div>
      </Router>
    </>
  );
}

export default App;
